
import { useState } from 'react';

import { InfinitePaginationDetails } from '../interfaces';
import { UseState } from '../types';

export const useInfinitePagination: (
  initialItemsCount?: number
) => InfinitePaginationDetails = (initialItemsCount: number = 50): InfinitePaginationDetails => {
  const [maxItems, setMaxItems]: UseState<number> = useState<number>(0);
  const [itemsCount, setItemsCount]: UseState<number> = useState<number>(initialItemsCount);
  const [hasMoreItems, setHasMoreItems]: UseState<boolean> = useState<boolean>(maxItems > initialItemsCount);
  const [offset, setOffset]: UseState<number> = useState<number>(0);

  const setMaxItemsValue: (value: number) => void = (value: number): void => {
    setMaxItems(value);
    setHasMoreItems(value > itemsCount);
  };

  const updateOffset: (newOffset: number) => void = (newOffset: number): void => {
    setOffset(newOffset);
  };

  const fetchMoreData: () => void = (): void => {
    setItemsCount(itemsCount + initialItemsCount); 

    if (hasMoreItems) {
      setTimeout((): void => {      
        updateOffset(itemsCount);
      }, 1500);
    }
  };

  const clearPagination: () => void = (): void => {
    updateOffset(0);
    setItemsCount(initialItemsCount);
  };

  const setDataAfterParamsLoad: (newOffset: number, newItemsCount: number) => void = (newOffset: number, newItemsCount: number): void => {
    updateOffset(newOffset);
    setItemsCount(newItemsCount);
    setHasMoreItems(maxItems > newItemsCount);
  };

  return {
    setMaxItems: setMaxItemsValue,
    hasMoreItems,
    fetchMoreData,
    paginationOffset: offset,
    initialItemsCount,
    maxItems,
    clearPagination,
    setDataAfterParamsLoad
  };
};
